import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class InvalidBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.invalid = {
            update: (element, valueAccessor, bindings, view, bindingContext) => {
                let text = ko.unwrap(valueAccessor());
                let controlContainerElement = $(element).closest('.c-control');

                if (text) {
                    if ($(element).children('.invalid-corner').length === 0) {
                        $('<div class="invalid-corner">').appendTo($(element)).hover(function (event) {
                            let it = $(element).children('.invalid-text');
                            if (it.length === 0) {
                                $('<div class="invalid-text">').appendTo($(element));
                                it = $(element).children('.invalid-text');
                            }
                            it.html(text);
                            it.css({ visibility: 'hidden', display: 'block', 'white-space': 'pre' });
                            let width = it.width();

                            let refLeft: number;
                            let ref: JQuery<Node> = $(element).closest('[data-role=window]').first();
                            if (ref.length === 0) {
                                ref = $(element).closest('[data-view]');
                            }
                            if (ref.length === 0) {
                                ref = $(document);
                                refLeft = 0;
                            }
                            else {
                                refLeft = ref.offset().left;
                            }

                            let refWidth = ref.width();
                            let itLeft = it.offset().left;
                            let itRel = itLeft - refLeft;

                            let maxWidth = (refWidth - itRel - 16);

                            if (maxWidth < 120) {
                                let posLeft = $(this).position().left;
                                maxWidth = $(this).offset().left - refLeft - 16;
                                it.css({ right: `${Math.max(0, $(this).offsetParent().width() - posLeft) + $(this).width()}px`, left: 'auto' });
                            }

                            if (width > maxWidth) {
                                it.css({ width: maxWidth + "px", "white-space": 'normal' });
                            }
                            it.css({ visibility: '', display: '' });

                            it.fadeIn('fast');

                            controlContainerElement.trigger('invalidation-text-shown');
                            controlContainerElement.data('invalidation-text-shown', true);

                        }, () => {
                            $(element).children('.invalid-text').remove();
                            controlContainerElement.removeData('invalidation-text-shown');
                        });
                    }

                    $(element).css('position', 'relative');
                } else {
                    $(element).children('.invalid-text').remove();
                    $(element).children('.invalid-corner').remove();
                }
            }
        };
    }
}